import type {SliceLike, SliceZoneComponents} from '@prismicio/vue';
import {sharedSlicesComponents, marketingSlicesComponents} from '#imports';
import {components as resourcesCenterComponents} from './index';

export const components = {...sharedSlicesComponents, ...marketingSlicesComponents, ...resourcesCenterComponents} as SliceZoneComponents<
    SliceLike<string>,
    unknown
>;
